export default __webpack_public_path__ + "static/media/logo.d718a794.png";